import { sanitizeText } from "../../../../utils/TextUtils";
import ProvinceField from "./ProvinceField";
import SelectAddress from "./SelectAddress";

const OrderFormFields = (
    {
        orderData,
        handleChange,
        setOrderData,
        showOptionProvince,
        setShowOptionProvince,
        searchQueryProvince,
        setSearchQueryProvince,
        handleProvinceSelection,
        toggleDropdownProvince,
        selectedProvince,
        setSelectedProvince,
        filteredProvinceList,
        allProvinceData,
        showOptionAddress,
        setShowOptionAddress,
        toggleDropdownAddress,
        addresses,
        handleAddressSelection,
        selectedAddressId,
    }) => {

    return (
        <div className="flex flex-wrap gap-4">

            {/* Destination Name */}
            {/* <div className="flex flex-col md:w-[38%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Nome <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_name"
                    placeholder="Nome"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_name || "")}
                    onChange={handleChange}
                />
            </div> */}

            <SelectAddress
                showOptionAddress={showOptionAddress}
                setShowOptionAddress={setShowOptionAddress}
                toggleDropdownAddress={toggleDropdownAddress}
                addresses={addresses}
                handleAddressSelection={handleAddressSelection}
                selectedAddressId={selectedAddressId}

                handleChange={handleChange}
                orderData={orderData}
            />

            {/* Destination Address */}
            <div className="flex flex-col md:w-[100%] lg:w-[48%] w-full gap-3">
                {/* <div */}
                {/* className={`flex flex-col w-full gap-3 ${orderData?.destination_name?.length > 0 ? 'md:w-[38%]' : 'md:w-[58%]'}`} */}
                {/* > */}
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Indirizzo <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_address"
                    placeholder="Indirizzo"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_address || "")}
                    onChange={handleChange}
                />
            </div>

            {/* Destination City */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Città <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_city"
                    placeholder="Città"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_city || "")}
                    onChange={handleChange}
                />
            </div>


            {/* Destination Postal Code */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[24%] w-full gap-3 ">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Cap <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_postal_code"
                    placeholder="Cap"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_postal_code || "")}
                    onChange={handleChange}
                />
            </div>


            <ProvinceField
                showOptionProvince={showOptionProvince}
                setShowOptionProvince={setShowOptionProvince}
                handleProvinceSelection={handleProvinceSelection}
                toggleDropdownProvince={toggleDropdownProvince}
                setSelectedProvince={setSelectedProvince}
                selectedProvince={selectedProvince}
                setSearchQueryProvince={setSearchQueryProvince}
                searchQueryProvince={searchQueryProvince}
                filteredProvinceList={filteredProvinceList}
                allProvinceData={allProvinceData}
            />


            {/* Destination Phone */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[32%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Telefono <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_phone"
                    placeholder="Telefono"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_phone || "")}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\+?\d*$/.test(value) || value === "") {
                            setOrderData({ ...orderData, destination_phone: value });
                        }
                    }}
                />
            </div>


            {/* Destination Mobile Phone */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[32%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Cellulare <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_mobile_phone"
                    placeholder="Cellulare"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_mobile_phone || "")}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\+?\d*$/.test(value) || value === "") {
                            setOrderData({ ...orderData, destination_mobile_phone: value });
                        }
                    }}
                />
            </div>


            {/* Destination Fax */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[32%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Fax
                </label>
                <input
                    type="text"
                    name="destination_fax"
                    placeholder="Fax"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={orderData.destination_fax || ""}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value) || value === "") {
                            setOrderData({ ...orderData, destination_fax: value });
                        }
                    }}
                />
            </div>

            {/* Destination Email */}
            <div className="flex flex-col md:w-[47.5%] lg:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                    Email <span className="text-red-500"> *</span>
                </label>
                <input
                    type="text"
                    name="destination_email"
                    placeholder="Email"
                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={sanitizeText(orderData.destination_email || "")}
                    onChange={handleChange}
                />
            </div>

        </div>
    );
};

export default OrderFormFields;
